module.exports = __webpack_public_path__ + "static/img/btn_beijingb_nor.9c067d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_beijingb_nor.png
// module id = +TUI
// module chunks = 1